// Third-party
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import * as ProposalNS from '../../Proposal';

// Components
import { DropdownMenu } from '../../../../views/components/inputs';
import { Tooltip } from '../../../../views/components/tooltips';
import { Button } from '../../../../views/components/buttons';

// Utils
import { formatMessage } from '../../../../utils/i18n';
import Dictionary from '@/types/dictionary';

type Props = {
  className?: string;
  proposal: ProposalNS.Proposal;
  viewKey: string;
  availableViews: string[];
  selectedViews: Dictionary<string>;
  setSelectedView: (key: string, value: string) => void;
};

enum ControlViews {
  Donut = 'DONUT',
  Table = 'TABLE',
  Bars = 'BARS',
  TableAndBars = 'TABLE_AND_BARS',
}

type State = {
  initialized: boolean;
};

const getViewIcon = (view: string): React.ReactNode => {
  switch (view) {
    case ControlViews.Table: {
      return <i className="icon-table" />;
    }
    case ControlViews.Donut: {
      return <i className="icon-donut" />;
    }
    case ControlViews.Bars: {
      return <i className="icon-bar-chart" />;
    }
    case ControlViews.TableAndBars: {
      return <i className="icon-table-and-bar-chart" />;
    }
    default:
      return null;
  }
};

class ProposalViewControl extends Component<Props> {
  readonly state: State = {
    initialized: false,
  };

  componentDidMount() {
    const { viewKey, setSelectedView, selectedViews } = this.props;
    if (selectedViews[viewKey] === undefined) {
      setSelectedView(viewKey, ControlViews.Table);
    }

    this.setState({ initialized: true });
  }

  onViewChanged(value: any) {
    const { viewKey, setSelectedView } = this.props;
    setSelectedView(viewKey, value);
  }

  render() {
    const { initialized } = this.state;
    const { selectedViews, availableViews, viewKey } = this.props;

    if (!initialized || availableViews.length === 0) {
      return null;
    }

    const selectedView = selectedViews[viewKey] != null ? selectedViews[viewKey] : availableViews[0];

    const dropdownOptions = availableViews.map(view => (
      <div key={view} className="view-item" onClick={() => this.onViewChanged(view)}>
        {getViewIcon(view)}
        <FormattedMessage id={`Proposal.ViewControl.Types.${view}`} />
      </div>
    ));

    return (
      <DropdownMenu className="proposal-view-control" options={dropdownOptions}>
        <Tooltip message={formatMessage('Proposal.ViewControl.Tooltip')}>
          <Button className="selected-view">
            {getViewIcon(selectedView)}
            <i className="icon-cheveron-down" />
          </Button>
        </Tooltip>
      </DropdownMenu>
    );
  }
}

export type ProposalViewControlProps = Props;

export default ProposalViewControl;
